import React from 'react';
import styled from '@emotion/styled';
import SessionStore from 'stores/shared/session';
import { loadLocales } from 'services/translation';
import { findDOMNode } from 'react-dom';
import './index.scss';

const SelectiveTourHeader = styled.div`
  align-items: center;
  background-color: ${(props) => props.backgroundColor || '#1a1a1a'};
  color: #fff;
  display: flex;
  font-size: 28px;
  font-family: inherit;
  font-weight: 400;
  height: 80px;
  justify-content: center;
`;

// override blue link text
const SelectiveHeaderLink = styled.a`
  color: #fff;

  &:hover {
    color: #fff;
  }
`;

const SelectiveHeaderLogo = styled.img`
  max-height: 60px;
  max-width: 100%;
`;

export default class extends React.Component {
  UNSAFE_componentWillMount() {
    const locale = this.props.tour
      ? this.props.tour.i18n_locale
      : this.props.i18n_locale;
    loadLocales(SessionStore.state.get('i18n') || locale); // TODO: replace props.tour.i18n etc with session store throughout front end
  }

  componentDidMount() {
    $(findDOMNode(this.refs.roundLogoContainer)).imagefill();
  }

  _renderSelectiveTourHeader = () => {
    const { color, display_name, guide_website_url, linkable_header, logo } =
      this.props;

    let content = display_name;
    if (logo) {
      content = <SelectiveHeaderLogo src={logo} alt={display_name} />;
    }
    if (linkable_header && guide_website_url) {
      content = (
        <SelectiveHeaderLink href={guide_website_url}>
          {content}
        </SelectiveHeaderLink>
      );
    }

    return (
      <SelectiveTourHeader backgroundColor={color}>
        {content}
      </SelectiveTourHeader>
    );
  };

  _linkHeader = () => {
    const { display_name, guide_website_url } = this.props;
    return (
      <a href={guide_website_url}>
        {this._renderAvatar()}
        {display_name}
      </a>
    );
  };

  _renderAvatar = () => {
    const { avatar_url } = this.props;

    if (avatar_url) {
      return (
        <div className="round-user-logo" ref="roundLogoContainer">
          <img src={avatar_url} className="loading" />
        </div>
      );
    }
  };

  render() {
    const { display_name, is_selective, linkable_header } = this.props;

    if (is_selective) {
      return this._renderSelectiveTourHeader();
    }

    return (
      <div className="ui inverted main menu WebsiteTourHeader">
        <div className="container">
          <div className="title item">
            {linkable_header ? this._linkHeader() : display_name}
          </div>
        </div>
      </div>
    );
  }
}
